import Abonent from '@/services/api/abonent.js';
import { app } from '@/main';

export default {
  namespaced: true,
  state: {
    abonents: [],
    abonent: {},
    deletedAbonents: [],
    deletedAbonent: {},
  },
  getters: {
    abonents: state => {
      return state.abonents.map(abonent => {
        abonent.fio = abonent.surname + ' ' + abonent.name + ' ' + abonent.patronymic;
        return abonent;
      });
    },
    abonent: state => state.abonent,
    deletedAbonents: state => state.deletedAbonents,
    deletedAbonent: state => state.deletedAbonent,
  },
  mutations: {
    setAbonents: (state, abonents) => {
      state.abonents = abonents;
    },
    setDeletedAbonents: (state, deletedAbonents) => {
      state.deletedAbonents = deletedAbonents;
    },
    setNewAbonent: (state, abonent) => {
      state.abonents.push(abonent);
    },
    setAbonent: (state, abonent) => {
      state.abonent = abonent;
    },
  },
  actions: {
    loadAbonents (state, options = {}) {
      return new Promise((resolve, reject) => {
        Abonent.getAbonents(options)
          .then(({ data }) => {
            state.commit('setAbonents', data.abonents);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },

    getAbonent (state, id) {
      return new Promise((resolve, reject) => {
        Abonent.getAbonent(id)
          .then(({ data }) => {
            state.commit('setAbonent', data.abonent);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },

    updateAbonent (state, {
      dataAbonent,
      idAbonent,
    }) {
      return new Promise((resolve, reject) => {
        Abonent.updateAbonent({
          dataAbonent,
          idAbonent,
        })
          .then(({ data }) => {
            state.commit('setAbonent', data.abonent);
            state.dispatch('getAbonent', idAbonent);
            resolve({ data });
          })
          .catch(e => reject(e));
      });
    },
    simpleUpdateAbonent (state, { dataAbonent, idAbonent }) {
      return new Promise((resolve, reject) => {
        Abonent.simpleUpdateAbonent({ dataAbonent, idAbonent })
          .then(({ data }) => {
            state.commit('setAbonent', data.abonent);
            resolve({ data });
          })
          .catch(e => reject(e));
      });
    },

    newAbonent (state, data) {
      return new Promise((resolve, reject) => {
        Abonent.newAbonent(data)
          .then((response) => {
            state.commit('setNewAbonent', response);
            resolve(response);
          })
          .catch(e => {
            Object.keys(e.response.data).forEach(key => {
              app.$flash_danger(e.response.data[key][0]);
            });
            reject(e);
          });
      });
    },

    abonentsCreateByPhone (state, params) {
      return new Promise((resolve, reject) => {
        Abonent.abonentsCreateByPhone(params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    deleteAbonent (state, { id, comment }) {
      return new Promise((resolve, reject) => {
        Abonent.deleteAbonent(id, comment)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    exportCsv (state) {
      return new Promise((resolve, reject) => {
        Abonent.exportCsv()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    exportCsvByAddress (state, doorphoneId) {
      return new Promise((resolve, reject) => {
        Abonent.exportCsvByAddress(doorphoneId)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    blockAccount (state, idAbonent) {
      return new Promise((resolve, reject) => {
        Abonent.blockAccount(idAbonent)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    unlockAccount (state, idAbonent) {
      return new Promise((resolve, reject) => {
        Abonent.unlockAccount(idAbonent)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    forbidCarNumberActivation (state, idAbonent) {
      return new Promise((resolve, reject) => {
        Abonent.forbidCarNumberActivation(idAbonent)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    allowCarNumberActivation (state, idAbonent) {
      return new Promise((resolve, reject) => {
        Abonent.allowCarNumberActivation(idAbonent)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    getDeletedAbonent (state, options = {}) {
      return new Promise((resolve, reject) => {
        Abonent.getDeletedAbonent(options)
          .then(({ data }) => {
            state.commit('setDeletedAbonents', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
